import { useTranslation } from 'react-i18next';

import { Stack } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { CheckIcon } from '../selectableCardGroup/CheckIcon';

import { formatDialogCount } from './formatDialogCount';
import {
  FeatureRow,
  Features,
  Header,
  OldPrice,
  Price,
  PriceBlock,
  StylesDivider,
  TariffCardContainer,
  TariffName,
} from './styles';

type TTariffCardProps = {
  name: string;
  price: number;
  oldPrice?: number;
  selected?: boolean;
  canWriteFirst: boolean;
  dialogCount: string;
  groupChatsEnabled: boolean;
  channelName?: string;
  priorityTechnicalSupport: boolean;
};

export const TariffCard = ({
  name,
  price,
  oldPrice,
  selected = false,
  canWriteFirst,
  dialogCount,
  groupChatsEnabled,
  priorityTechnicalSupport,
  channelName,
}: TTariffCardProps) => {
  const { t } = useTranslation();
  const displayedDialogCount = formatDialogCount(
    dialogCount,
    t('billing:tariffFeatures.unlimited')
  );

  return (
    <TariffCardContainer>
      <Header>
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          gap="5px"
        >
          <CustomTypography variant="h4">{channelName}</CustomTypography>
          {channelName !== 'Telegram Bot' && (
            <TariffName variant="h4">{name}</TariffName>
          )}
        </Stack>
        <CheckIcon selected={selected} />
      </Header>
      <PriceBlock>
        <Price variant="h4" selected={selected}>
          {price.toLocaleString()} ₽
        </Price>
        {oldPrice && (
          <OldPrice variant="body2" selected={selected}>
            {oldPrice.toLocaleString()} ₽
          </OldPrice>
        )}
      </PriceBlock>

      <StylesDivider />

      <Features>
        <FeatureRow>
          <span>{t('billing:tariffFeatures.canWriteFirst')}</span>
          <span>
            {canWriteFirst
              ? t('billing:tariffFeatures.yes')
              : t('billing:tariffFeatures.no')}
          </span>
        </FeatureRow>
        <FeatureRow>
          <span>{t('billing:tariffFeatures.dialogCount')}</span>
          <span>{displayedDialogCount}</span>
        </FeatureRow>
        {channelName &&
          !channelName.includes('Telegram') &&
          channelName !== 'MAX' && (
            <FeatureRow>
              <span>{t('billing:tariffFeatures.groupChats')}</span>
              <span>
                {groupChatsEnabled
                  ? t('billing:tariffFeatures.yes')
                  : t('billing:tariffFeatures.no')}
              </span>
            </FeatureRow>
          )}
        <FeatureRow>
          <span>{t('billing:tariffFeatures.priorityTechnicalSupport')}</span>
          <span>
            {priorityTechnicalSupport
              ? t('billing:tariffFeatures.yes')
              : t('billing:tariffFeatures.no')}
          </span>
        </FeatureRow>
      </Features>
    </TariffCardContainer>
  );
};
